import { useAws } from "src/networking/aws";
import {
  AwsGateCallbacks,
  AwsGateRequest,
  GetQuestionnaire,
  PostQuestionnaire,
} from "src/types";

export const useGetQuestionnaire = <
  T extends GetQuestionnaire["request"],
  D extends GetQuestionnaire["response"]
>() => {
  const hook = useAws<T, D>("getQuestionnaire");

  return {
    ...hook,
    crossGate: (request: AwsGateRequest<T>, callbacks: AwsGateCallbacks<D>) => {
      return hook.crossGate(
        {
          method: "get",
          path: `/polizze/${request.uriParams.idPolizza}/questionari/${request.uriParams.codQuestionario}`,
          ...request,
        },
        callbacks
      );
    },
  };
};

export const usePostQuestionnaire = <
  T extends PostQuestionnaire["request"],
  D extends PostQuestionnaire["response"]
>() => {
  const hook = useAws<T, D>("postQuestionnaire");

  return {
    ...hook,
    crossGate: (request: AwsGateRequest<T>, callbacks: AwsGateCallbacks<D>) => {
      return hook.crossGate(
        {
          method: "post",
          path: `/polizze/${request.uriParams.idPolizza}/questionari/validate`,
          ...request,
        },
        callbacks
      );
    },
  };
};
